// 変数定義
//-------------------------------------------------
let scrollY = 0.0; // fixed用位置記憶変数
let fixedFlag = false; // メニューfixフラグ
let hoverLevel = 0; // 何処にホバーしたかを記録
let hiddenNavFlag = false; // ナビゲーションが隠れたかどうかのフラグ
let upperScrollCheckPos = 0; // 上スクロールされたかどうかを判断するために位置保持用
const winH = window.innerHeight;

// オブジェクトを取得
//-------------------------------------------------
// タグを取得
const modalNavWrap = document.getElementsByClassName("modal-nav-wrap");
// ナビゲーションボタンのタグを取得
const navButton = document.getElementById("nav-button-wrap");


// // クリックでクラスをトグル（メニュー開閉）
// //-------------------------------------------------
// // ハンバーガーメニューのアクティブクラスを付与する関数
const navButtonToggle = e => {
    if (typeof window !== `undefined`) {
        if (window.innerWidth <= 959) {
            // タグ名を取得しておく
            let clickTagName = e.target.offsetParent.id;
            // fixフラグを確認
            if (!fixedFlag && clickTagName !== "modal-nav-wrap") {
                // OFFであれば現在スクロールを取得
                scrollY = window.pageYOffset;
                // fixフラグを真に
                fixedFlag = true;
            } else {
                // ONであればfixフラグを偽に
                fixedFlag = false;
            }

            // ボタンは常時動作・背景はオープン時のみ駆動
            if (!fixedFlag && clickTagName === "modal-nav-wrap" || clickTagName === "nav-button-wrap") {
                // SPボタンに指定クラスがあるか確認
                if (navButton.classList.contains("active-navigation")) {
                    // あればメニューモードなのでそれぞれのクラスを除外後、スクロールリスナーを外す
                    // modalNavWrap[0].classList.remove("fixed-main-wrap");
                    navButton.classList.remove("active-navigation");
                    //   navUL[0].classList.remove("openNavi");
                    document.body.classList.remove("sp-menu-open");
                } else {
                    // なければメニューモードに移行処理、スクロールリスナーを付ける
                    // modalNavWrap.classList.add("fixed-main-wrap");
                    navButton.classList.add("active-navigation");
                    document.body.classList.add("sp-menu-open");
                    //   navUL[0].classList.add("openNavi");
                }
                // fixを付与・解除した後の処理
                if (fixedFlag) {
                    // ONであればmodalNavWrap[0]のスタイルにTOPを現在スクロール値を与える
                    //   modalNavWrap[0].style.left = -scrollY+"%";
                    document.documentElement.style.scrollBehavior = "auto";
                } else {
                    // OFFであれば
                    //   modalNavWrap[0].style.left = "";
                    window.scrollTo(0, scrollY);
                    document.documentElement.style.scrollBehavior = "";
                }
            }
        }
    }
};



// ホバーで子ナビゲーションを表示
var parentLi = document.querySelectorAll("#parent-ul > li");
if (window.innerWidth > 959) {
    for (var i = 0; i < parentLi.length; i++) {
        parentLi[i].addEventListener("mouseover", function () {
            var childUl = this.querySelector(".child-ul");
            if (childUl) {
                // フェードアウトアニメーションをキャンセルして子メニューを表示
                childUl.style.display = "block";
                childUl.style.opacity = 1;
            }
        });
        parentLi[i].addEventListener("mouseout", function (e) {
            var childUl = this.querySelector(".child-ul");
            if (childUl && !this.contains(e.relatedTarget)) {
                childUl.style.opacity = 0;
                childUl.addEventListener("transitionend", function () {
                    // 透明度が0になったら非表示にする
                    if (childUl.style.opacity === "0") {
                        childUl.style.display = "none";
                    }
                }, {
                    once: true
                });
            }
        });
    }
}

let navToggleCheck = {};
function ntck(e, click_or_touch,after_function){//この関数を使って問題を解決する
    if(navToggleCheck.status){//データがある時
        if(navToggleCheck.status == click_or_touch){//1000ms前の入力方法と同じ
            after_function(e);//処理を実行する
        }
    }else{//データが無い時
        navToggleCheck.status = click_or_touch;//入力方法を記録
        setTimeout(function(){
            delete navToggleCheck.status;//データを削除する
        },1000/*データが削除されるまでの時間(ms)*/);
        after_function(e);//処理を実行する
    }
}

// 各spanタグにクリックイベントリスナーを設定
navButton.addEventListener("mouseup", e => {ntck(e, "mouse",navButtonToggle)});
navButton.addEventListener("touchend", e => {ntck(e, "touch", navButtonToggle)});